import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { PhoneCTA } from "@/components/contacting/Buttons/PhoneButton";
import { usePlatoAvailable, useProviderSection } from "@/contexts/contact";
import { BookVisitButton } from "../Buttons";
import { MailButton } from "../Buttons/MailButton";
export const MobileContactCtas = ({ testId }) => {
    var _a;
    const { t } = useI18n();
    const { phoneNumbers = [] } = (_a = useProviderSection()) !== null && _a !== void 0 ? _a : {};
    const isPlatoAvailable = usePlatoAvailable();
    return (_jsxs(Box, { gap: "spacing.12", alignItems: "center", flexDirection: "column", marginTop: "spacing.24", display: {
            "breakpoint.base": "flex",
            "breakpoint.sm": "none",
        }, children: [_jsx(MailButton, { av_zone: "detail_agency_block", legacyTrackingInfos: "detail-bottom", rootTestId: testId }), _jsxs(Box, { display: "flex", flexDirection: isPlatoAvailable ? "row" : "column", width: "100%", gap: "spacing.12", children: [_jsx(PhoneCTA, { trackingAvZone: "detail_agency_block", legacyTrackingInfos: "detail-bottom" //tracking GA3 for harvest
                        , rootTestId: `${testId}`, phoneNumbers: phoneNumbers, children: t("contact.mobile_sticky.phone") }), isPlatoAvailable && (_jsx(BookVisitButton, { av_zone: "sticky", rootTestId: testId, children: t("contact.cta.book_visit") }))] })] }));
};
